import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function ShareSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.86 1.525a1.764 1.764 0 100 3.528 1.764 1.764 0 000-3.528zm-3.264 1.764a3.264 3.264 0 11.884 2.234L7.255 9.06a3.265 3.265 0 010 1.868l6.225 3.536a3.264 3.264 0 11-.748 1.3l-6.225-3.536a3.264 3.264 0 110-4.468l6.224-3.537a3.262 3.262 0 01-.136-.934zM2.362 9.994a1.764 1.764 0 113.528 0 1.764 1.764 0 01-3.528 0zm11.732 6.704a1.764 1.764 0 113.529 0 1.764 1.764 0 01-3.528 0z",
    clipRule: "evenodd"
  }));
}

export default ShareSmall;
//# sourceMappingURL=ShareSmall.js.map